(() => {
  if (window.__collectionProductProgressStarted) return;
  window.__collectionProductProgressStarted = true;

  const parseCount = (value) => Number(String(value).replace(/\D/g, ''));

  const getTotalProducts = (sourceCount) => {
    const matches = sourceCount.textContent.match(/\d[\d\s\u00a0.,]*/g) || [];
    const counts = matches.map(parseCount).filter(Number.isFinite);
    return counts.length ? counts[counts.length - 1] : null;
  };

  const getDisplayedProducts = (section) => {
    const productGrid = section.querySelector('#product-grid');
    if (!productGrid) return null;

    return productGrid.querySelectorAll(
      ':scope > .grid__item.js-pagination__item:not(.collection-inline-promo):not(.collection-link-tile-item)'
    ).length;
  };

  const updateProductProgress = (root = document) => {
    root.querySelectorAll('.section-main-collection-product-grid').forEach((section) => {
      const displayedProducts = getDisplayedProducts(section);
      if (!Number.isFinite(displayedProducts)) return;

      section.querySelectorAll('.js-product-count').forEach((sourceCount) => {
        const totalProducts = getTotalProducts(sourceCount);
        if (!Number.isFinite(totalProducts)) return;

        let progress = sourceCount.previousElementSibling;
        if (!progress?.classList.contains('collection-product-progress')) {
          progress = document.createElement('span');
          progress.className = 'collection-product-progress';
          sourceCount.insertAdjacentElement('beforebegin', progress);
        }

        const shownProducts = Math.min(displayedProducts, totalProducts);
        const nextText = `Wyświetlono ${shownProducts} z ${totalProducts} produktów`;

        if (progress.textContent !== nextText) {
          progress.textContent = nextText;
        }

        sourceCount.hidden = true;
        sourceCount.setAttribute('aria-hidden', 'true');
      });
    });
  };

  const initialize = () => {
    updateProductProgress();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('collection:products-updated', initialize);
})();
